export default __webpack_public_path__ + "static/media/02video_btn.44b1d3ff.png";